import {
  type Dropdown,
  type PaginatedDropdownList,
  type UsersListListData,
  CallTypeEnum,
  usersListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect, RangePickerFilter } from '@crm/components'
import { useQueryParams, useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Select } from 'antd'

export const CallsFilter = () => {
  const { t } = useLocales()
  const params = useQueryParams()
  const { updateQuery } = useQueryUpdate()

  const filterTypeOptions = Object.values(CallTypeEnum).map((item) => ({
    label: t(`calls.${item}`),
    value: item
  }))

  return (
    <>
      <InfiniteSelect<UsersListListData, PaginatedDropdownList, Dropdown>
        value={params.agent}
        className="select-min-width"
        popupMatchSelectWidth
        placeholder={t('filter.lead_owner')}
        getQueryFunction={usersListListInfiniteOptions}
        onChange={(agent) => updateQuery({ agent })}
        baseOptions={{
          query: {
            preference: params?.agent
          }
        }}
      />

      <Select
        allowClear
        placeholder={t('filter.type')}
        value={params.type}
        onChange={(type) => updateQuery({ type })}
        className="select-min-width"
        options={filterTypeOptions}
      />

      <RangePickerFilter
        fromParam="created_at_start"
        toParam="created_at_end"
        placeholder={[t('filter.date_from'), t('filter.date_to')]}
      />
    </>
  )
}
